import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setCart, setCheckout, shouldAddOrUpdateHawaiiGetSelector } from "src/features/checkout/checkoutSlice"
import { useLazyGetCheckoutQuery } from "src/features/checkout/storefrontApi"
import { useAddHawaiiGetMutation } from "src/features/checkout/checkoutApi"
import { useLazyGetCartQuery } from "src/features/checkout/storefrontCartApi"

export default function HawaiiGet() {
  const dispatch = useDispatch()
  const { cart } = useSelector((state) => state.checkout)
  const { deliveryOption } = useSelector((state) => state.checkout.options)
  const shouldAddOrUpdateHawaiiGet = useSelector(shouldAddOrUpdateHawaiiGetSelector)

  const [
    addHawaiiGet,
    {
      isLoading: hawaiiGetLoading,
    }
  ] = useAddHawaiiGetMutation()

  const [
    getCart,
    { data: getCartData, isLoading: getCartLoading },
  ] = useLazyGetCartQuery()

  useEffect(() => {
    if (getCartData?.cart) {
      dispatch(setCart(getCartData.cart))
    }
  }, [getCartData])

  useEffect(() => {
    console.log('shouldAddOrUpdateHawaiiGet', shouldAddOrUpdateHawaiiGet)
    if (shouldAddOrUpdateHawaiiGet) {
      addHawaiiGet({
        checkoutId: cart.id
      }).then(() => getCart(cart.id, false))
    }
  }, [deliveryOption, shouldAddOrUpdateHawaiiGet])

  return <></>
}
